console.log("🚀 Shopify Theme by Brave The Skies");

// variant image change in YOU MAY ALSO LIKE in cart 
document.addEventListener('change', async function (e) {

    if (!e.target.matches('.obvDropdownSelector')) {
        return;
    }

    const variantId = e.target.value;

    try {

        const response = await fetch(`/variants/${variantId}.js`);
        const variant = await response.json();

        const imageUrl =
            variant?.featured_image?.src ||
            variant?.featured_media?.preview_image?.src;

        if (!imageUrl) {
            return;
        }

        const cartItem = e.target.closest('.cart-item');

        if (!cartItem) {
            return;
        }

        const image = cartItem.querySelector('.obvLazyImage__image');

        if (image) {

            image.src = imageUrl;

            image.srcset = `
                ${imageUrl}&width=50 50w,
                ${imageUrl}&width=100 100w,
                ${imageUrl}&width=200 200w
            `;

        }

    } catch (error) {

        console.error(
            'Failed to update Obviyo variant image:',
            error
        );

    }

});
// END variant image change in YOU MAY ALSO LIKE in cart 


// Hide Stikcy Add to cart at the footer 

document.addEventListener('DOMContentLoaded', () => {
    const stickyBar = document.querySelector('#main-product-form');
    const footer = document.querySelector('footer');

    if (!stickyBar || !footer) return;

    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    stickyBar.classList.add('hide');
                } else {
                    stickyBar.classList.remove('hide');
                }
            });
        },
        { threshold: 0.1 }
    );

    observer.observe(footer);
});